import { render, staticRenderFns } from "./FormGroup.vue?vue&type=template&id=3921f250&scoped=true&"
import script from "./FormGroup.vue?vue&type=script&lang=ts&"
export * from "./FormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3921f250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3921f250')) {
      api.createRecord('3921f250', component.options)
    } else {
      api.reload('3921f250', component.options)
    }
    module.hot.accept("./FormGroup.vue?vue&type=template&id=3921f250&scoped=true&", function () {
      api.rerender('3921f250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/accountApplication/accountApplicationForm/FormGroup.vue"
export default component.exports